import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { RouterOutlet } from '@angular/router';
import { AuthState } from './core/models/auth.model';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { GameSessionCheckService } from './core/services/game-session-check.service';
import { merge, fromEvent, startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TextOnlySnackBar } from '@angular/material/snack-bar';
import * as AuthActions from './core/store/auth/auth.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  public title = 'xedoom';
  private readonly store = inject(Store<{ auth: AuthState, gameSession: any }>);
  private destroy$ = new Subject<void>();
  private windowAvailable = typeof window !== 'undefined';

  constructor(
    private sessionCheckService: GameSessionCheckService,
    private snackBar: MatSnackBar
  ) {
    if (this.windowAvailable) {
      const online$ = merge(
        fromEvent(window, 'online').pipe(map(() => true)),
        fromEvent(window, 'offline').pipe(map(() => false))
      ).pipe(startWith(navigator.onLine));

      let snackRef: MatSnackBarRef<TextOnlySnackBar> | null = null;

      online$.subscribe(isOnline => {
        if (!isOnline && !snackRef) {
          // Show persistent "offline" banner
          snackRef = this.snackBar.open('You are offline', undefined, {
            panelClass: 'errorNotificationMessage',
            duration: undefined, // don't auto-close
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
        } else if (isOnline && snackRef) {
          // Close it once back online
          snackRef.dismiss();
          snackRef = null;

          // Optional “back online” confirmation
          this.snackBar.open('Back online', '', {
            duration: 2000,
            panelClass: 'successNotificationMessage'
          });
        }
      });
    }
  }

  ngOnInit() {
    this.store.dispatch(AuthActions.initAuth());
    // Check for active session when user is authenticated
    this.sessionCheckService.checkSession(this.destroy$)
      .subscribe({
        error: error => console.error('Session check error:', error)
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
